// A login whose invite was a BigFinance-only one (invite-user's app-role mode,
// supabase/functions/_shared/appRoleInvite.ts): an outside accountant with a
// BigFinance role and NO membership. The invite wrote where BigFinance lives
// into their metadata (`invited_app_url`, from the server's bigFinanceUrl()),
// because BigFinance is its own app at its own address, not a page of this one.

interface BigFinanceOnlyLogin {
  /** BigFinance's address (an https origin), or null when the invite carried
   *  none (invites sent before it did) or carried something that isn't one. */
  url: string | null
}

/** Reads a session's user_metadata. Null unless the invite was a BigFinance
 *  one. Only an https origin is ever handed back: the metadata is the user's
 *  own to edit, so nothing else in it may become a link. */
export function bigFinanceOnlyLogin(userMetadata: unknown): BigFinanceOnlyLogin | null {
  if (!userMetadata || typeof userMetadata !== 'object') return null
  const meta = userMetadata as Record<string, unknown>
  if (meta.invited_app !== 'bigfinance') return null
  return { url: httpsOrigin(meta.invited_app_url) }
}

/** The https origin of `v`, or null for anything else (a javascript: or
 *  http: address, a non-string). Every BigFinance address shown as a link
 *  passes through here. */
export function httpsOrigin(v: unknown): string | null {
  if (typeof v !== 'string' || !v) return null
  try {
    const u = new URL(v)
    return u.protocol === 'https:' ? u.origin : null
  } catch {
    return null
  }
}
